import React from "react";
import styles from "./styles.module.css";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";

export function CustomTabs({ tabsArray, onClick, active }: any) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <div
      className={`${styles.tabsContainer} ${isDarkMode ? styles.darkMode : ""}`}
    >
      {tabsArray?.length
        ? tabsArray.map((state: any, idx: any) => {
            return (
              <button
                key={idx}
                type="button"
                className={state.key === active ? styles.activeTab : ""}
                onClick={() => onClick(state.key)}
              >
                {state.label}
              </button>
            );
          })
        : ""}
    </div>
  );
}
